<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12 sm12 lg4>
        <material-chart-card
          :data="discountChart.data"
          :options="discountChart.options"
          :responsive-options="discountChart.responsiveOptions"
          color="green"
          type="Bar"
          inline
        >
          <h4 class="title font-weight-light">Economia</h4>
          <p class="category d-inline-flex font-weight-light">
            Sua economia nos últimos 12 meses
          </p>

          <template slot="actions">
            <v-icon class="mr-2" small> sentiment_very_satisfied </v-icon>
            <span class="caption grey--text font-weight-light"
              >R$ {{ formatCurrencyEmail(total_discount) }} economizado!</span
            >
          </template>
        </material-chart-card>
      </v-flex>
      <v-flex md12 sm12 lg4>
        <material-chart-card
          :data="totalChart.data"
          :options="totalChart.options"
          :responsive-options="totalChart.responsiveOptions"
          color="#095F96"
          type="Line"
        >
          <h4 class="title font-weight-light">Gasto em Energia</h4>
          <p class="category d-inline-flex font-weight-light">
            Confira seus gastos em energia
          </p>

          <template slot="actions">
            <v-icon class="mr-2" small> flash_on </v-icon>
            <span class="caption grey--text font-weight-light"
              >R$
              {{ formatCurrencyEmail(total_total_utility_company) }} consumido
              de energia!</span
            >
          </template>
        </material-chart-card>
      </v-flex>
      <v-flex md12 sm12 lg4>
        <v-flex sm12 xs12 md12 lg12>
          <material-stats-card
            color="green"
            icon="sentiment_very_satisfied"
            title="Economia"
            :value="formatCurrency(total_discount)"
            sub-icon="mdi-solar-power"
            sub-text="Energia Limpa"
          />
        </v-flex>
        <v-flex sm12 xs12 md12 lg12>
          <material-stats-card
            color="orange"
            icon="flash_on"
            title="Gasto em energia"
            :value="formatCurrency(total_total_utility_company)"
            sub-icon="mdi-flag-variant"
            sub-text="Energia que move sua vida"
            sub-text-color="text-primary"
          />
        </v-flex>
      </v-flex>
      <v-flex xs12 md12>
        <material-card class="card-tabs" color="#095F96">
          <v-flex slot="header">
            <v-tabs
              v-model="tabs"
              color="transparent"
              slider-color="white"
              mandatory
              value="1"
            >
              <span
                class="subheading font-weight-light mr-3"
                style="align-self: center"
                >Faturas:</span
              >
              <v-tab
                class="mr-3"
                v-for="(invoice, i) in invoices"
                :key="invoice.competence"
                :href="'#tab-' + i"
              >
                <v-icon class="mr-2">{{
                  invoice.status === "paga" || invoice.status === "succeeded"
                    ? "mdi-check"
                    : "mdi-alarm-multiple"
                }}</v-icon>
                {{ invoice.competence | formatarData }}
              </v-tab>
            </v-tabs>
          </v-flex>

          <v-tabs-items v-model="tabs">
            <v-tab-item
              v-for="(invoice, i) in invoices"
              :key="invoice.competence"
              :value="'tab-' + i"
              mandatory
            >
              <v-card fluid flat>
                <v-card-text>
                  <v-container fluid grid-list-md>
                    <v-layout row wrap>
                      <v-flex sm12 md6>
                        <h2>{{ invoice.competence | formatarData }}</h2>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-container fluid grid-list-md>
                  <v-layout row wrap>
                    <v-flex sm12 md6>
                      <v-card fluid flat style="padding: 10px">
                        <v-card-title
                          primary-title
                          class="text-md-right text-sm-right"
                          style="
                            background-color: #506670;
                            padding: 20px;
                            color: #fff;
                          "
                        >
                          <div class="headline mb-1">
                            <v-icon>flash_on</v-icon>
                            Sua conta com a concessionária
                          </div>
                        </v-card-title>
                        <v-card-text class="card-text concessionaria">
                          <v-layout row wrap class="line">
                            <v-flex sm6 md6> Total Conta Energia </v-flex>
                            <v-flex
                              sm6
                              md6
                              class="text-md-right text-sm-right"
                              align-end
                              flexbox
                            >
                              <h4>
                                R$
                                {{
                                  invoice.total_utility_company | formatCurrency
                                }}
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-divider v-if="invoice.custo_disp > 0"></v-divider>
                          <v-layout
                            row
                            wrap
                            class="line"
                            v-if="invoice.custo_disp > 0"
                          >
                            <v-flex sm6 md6>
                              Dif. Custo de Disponibilidade<br /><small
                                >Res. 482</small
                              >
                            </v-flex>
                            <v-flex sm6 md6 class="text-md-right text-sm-right">
                              <h4>
                                R$ ({{ invoice.custo_disp | formatCurrency }})
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap class="line">
                            <v-flex sm6 md6>
                              Creditos Recebidos<br /><small
                                >Energia Injetada</small
                              >
                            </v-flex>
                            <v-flex sm6 md6 class="text-md-right text-sm-right">
                              <h4>
                                R$ ({{ invoice.amount | formatCurrency }})
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap>
                            <v-flex sm6 md6>
                              Pagamento <br />
                              <small>Concessionária</small>
                            </v-flex>
                            <v-flex
                              sm6
                              md6
                              class="text-md-right text-sm-right text-lg-right"
                            >
                              <h4>
                                R$ {{ invoice.total_invoice | formatCurrency }}
                              </h4>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>

                    <v-flex sm12 md6>
                      <v-card fluid flat style="padding: 10px">
                        <v-card-title
                          primary-title
                          class="text-md-right text-sm-right"
                          style="
                            background-color: #095f96;
                            padding: 20px;
                            color: #fff;
                          "
                          padding
                        >
                          <div class="headline mb-1">
                            <v-icon color="#FFF">wb_sunny</v-icon>
                            Sua conta de energia limpa
                          </div>
                        </v-card-title>
                        <v-card-text class="card-text energia-limpa">
                          <v-layout row wrap class="line">
                            <v-flex sm6 md6> Creditos Recebidos<br /> </v-flex>
                            <v-flex sm6 md6 class="text-md-right text-sm-right">
                              <h4>
                                R$ ({{ invoice.amount | formatCurrency }})
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap class="line">
                            <v-flex sm6 md6> Desconto de 20% </v-flex>
                            <v-flex sm6 md6 class="text-md-right text-sm-right">
                              <h4>
                                R$ {{ (invoice.amount * 0.2) | formatCurrency }}
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap class="line">
                            <v-flex sm6 md6>
                              Pagamento<br />
                              <small>Energia Limpa</small>
                            </v-flex>
                            <v-flex sm6 md6 class="text-md-right text-sm-right">
                              <h4>R$ {{ invoice.total | formatCurrency }}</h4>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex sm12 md12>
                      <v-card fluid flat style="padding: 10px">
                        <v-card-title
                          primary-title
                          class="text-md-right text-sm-right"
                          style="
                            background-color: #00a8bb;
                            padding: 20px;
                            color: #fff;
                          "
                        >
                          <div class="headline mb-0">
                            <v-icon color="#FFF">favorite</v-icon>
                            Economia de verdade
                          </div>
                        </v-card-title>
                        <v-card-text class="card-text economia">
                          <v-layout row wrap>
                            <v-flex sm6 md6>
                              Antes você pagaria<br /><small
                                >Concessionária</small
                              >
                            </v-flex>
                            <v-flex
                              sm6
                              md6
                              class="text-md-right text-sm-right"
                              v-if="invoice.custo_disp"
                            >
                              <h4>
                                R$
                                {{
                                  invoice.total_utility_company | formatCurrency
                                }}
                              </h4>
                            </v-flex>
                            <v-flex
                              sm6
                              md6
                              class="text-md-right text-sm-right"
                              v-if="!invoice.custo_disp"
                            >
                              <h4>
                                R$
                                {{
                                  (invoice.amount + invoice.total_invoice)
                                    | formatCurrency
                                }}
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap>
                            <v-flex sm6 md6>
                              Agora você paga<br /><small
                                >Concessionária + Energia Limpa</small
                              >
                            </v-flex>
                            <v-flex sm6 md6 class="text-md-right text-sm-right">
                              <h4>
                                R$
                                {{
                                  (invoice.total + invoice.total_invoice)
                                    | formatCurrency
                                }}
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-divider></v-divider>
                          <v-layout row wrap>
                            <v-flex sm6 md6>
                              <h3 style="color: #506670">
                                {{
                                  invoice.discount * 1 > 0
                                    ? "Você Economizou"
                                    : "Esse mês não houve economia"
                                }}
                              </h3>
                            </v-flex>
                            <v-flex sm6 md6 class="text-md-right text-sm-right">
                              <h3 style="color: #506670">
                                R$ {{ (invoice.discount * 1) | formatCurrency }}
                              </h3>
                            </v-flex>
                          </v-layout>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex
                      v-if="
                        invoice.transaction &&
                        (invoice.status === 'aberta' ||
                          invoice.status === 'pending' ||
                          invoice.status === 'wait_payment') &&
                        invoice.transaction.payment_method === 'boleto'
                      "
                    >
                      <div
                        class="form-control wizard-form-control d-flex align-items-center testing-code px-20px mb-10px"
                      >
                        <span class="title">Código de Barras:</span>
                        <span
                          @click.stop.prevent="copyTestingCode"
                          class="code text-red"
                        >
                          {{ invoice.transaction.boleto_barcode }}
                          <v-icon>mdi-content-copy</v-icon>
                        </span>

                        <input
                          type="hidden"
                          id="testing-code"
                          :value="invoice.transaction.boleto_barcode"
                        />
                      </div>
                      <p id="`boleto_${invoice.competence}`">
                        <iframe
                          :src="invoice.transaction.boleto_url"
                          type="application/pdf"
                          frameborder="0"
                          width="100%"
                          height="1500"
                        ></iframe>
                      </p>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-flex>
      <v-snackbar
        :color="color"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        v-model="snackbar"
        dark
      >
        <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
        <div>{{ snackMessage }}</div>
        <v-icon size="16" @click="snackbar = false"> mdi-close-circle </v-icon>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
import {
  // addInvoice,
  updateInvoice,
  // getInvoice,
  // getInvoices
} from "../services/invoices";
import moment from "moment";
import { addTransaction, addBuyer } from "../services/creditcards";
import { GET_DETAILBILLING_BY_USER } from "../graphql/billing";
import { mapState } from "vuex";
export default {
  props: ["selected"],
  computed: {
    ...mapState(["user"]),
  },
  data: () => ({
    total_discount: 0,
    total_total_utility_company: 0,
    discountChart: {
      data: {
        labels: [],
        series: [[]],
      },
      options: {
        seriesBarDistance: 15,
        fullWidth: true,
        axisX: {
          showGrid: false,
        },
        chartPadding: {
          top: 15,
          right: 5,
          bottom: 0,
          left: 0,
        },
      },
      responsiveOptions: [
        [
          "screen and (min-width: 641px) and (max-width: 1024px)",
          {
            seriesBarDistance: 10,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value;
              },
            },
          },
        ],
      ],
    },
    totalChart: {
      data: {
        labels: [],
        series: [[]],
      },
      options: {
        seriesBarDistance: 15,
        fullWidth: true,
        axisX: {
          showGrid: false,
        },
        chartPadding: {
          top: 15,
          right: 5,
          bottom: 0,
          left: 0,
        },
      },
      responsiveOptions: [
        [
          "screen and (min-width: 641px) and (max-width: 1024px)",
          {
            seriesBarDistance: 10,
            axisX: {
              labelInterpolationFnc: function (value) {
                return value;
              },
            },
          },
        ],
      ],
    },
    month_desc: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez",
    ],
    loading: false,
    loading_faturar: false,
    color: null,
    colors: ["purple", "info", "success", "warning", "error"],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackMessage: "",
    snackbar: false,
    valid: false,
    invoices: [],
    tabs: 0,
    list: {
      0: false,
      1: false,
      2: false,
      3: true,
    },
    dialog: false,
  }),
  mounted() {
    this.tabs = this.selected;
  },
  created() {
    this.loading = true;
    if (this.user) {
      this.$apollo
        .query({
          // gql query
          query: GET_DETAILBILLING_BY_USER,
          // Reactive parameters
          variables: {
            // Use vue reactive properties here
            customer_id: this.user.customer_id,
          },
        })
        .then((billing) => {
          // Seta as faturas no eventBus para o outro Componente
          this.invoices = billing.data.billing;

          billing.data.billing.forEach((data) => {
            this.discountChart.data.labels.push(data.competence);
            this.total_discount = this.total_discount + data.discount;
            this.discountChart.data.series[0].push(data.discount);
            this.totalChart.data.labels.push(data.competence);
            this.totalChart.data.series[0].push(data.total_utility_company * 1);
            this.total_total_utility_company =
              this.total_total_utility_company +
              (data.total_utility_company * 1 || 0);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error(error);
          this.valid = true;
          this.loading = false;
        });
    }
  },
  methods: {
    async faturarBoleto(buyer, invoice) {
      this.loading_faturar = true;
      // console.log('buyer: ', buyer)
      // console.log('buyer_id: ', buyer.buyer_id)
      if (buyer.buyer_id) {
        await this.geraBoleto(invoice, buyer.buyer_id)
          .then((boleto) => {
            // console.log('boleto: ', boleto)
            // console.log('competence: ', invoice.competence)
            const month = invoice.competence.toString().split("-")[1];
            const year = invoice.competence.toString().split("-")[0];

            // console.log('comp: ' + year + '-' + month )
            const invoice_update = {
              competence: year + "-" + month,
              transaction_id: boleto.data.id,
              transaction_history: boleto.data.history,
              transaction_status: boleto.data.status,
              transaction_customer: boleto.data.customer,
              transaction_created_at: boleto.data.updated_at,
              "transaction.payment_method": boleto.data.payment_method,
            };
            updateInvoice(buyer.customer_id, invoice_update)
              .then(() => {
                // console.log(req)
                this.loading_faturar = false;
                this.snack("Boleto gerado com sucesso!", "success", "bottom");

                // this.$route.replace('membros/faturas/' + this.buyer_id.customer_id)
              })
              .catch((error) => {
                console.error(
                  "Erro ao atualizar a fatura, transação realizada com o número: " +
                    boleto.data.id +
                    " Erro: " +
                    error,
                );
                this.loading_faturar = false;
                this.snack(
                  "Erro ao atualizar a fatura, transação realizada com o número: " +
                    boleto.data.id +
                    " Erro: " +
                    error,
                  "error",
                  "bottom",
                );
              });
          })
          .catch((error) => {
            console.error("Erro ao gerar boleto - Erro: " + error);
            this.loading_faturar = false;
            this.snack(
              "Erro ao gerar boleto - Erro: " + error,
              "error",
              "bottom",
            );
          });
      } else {
        const newBuyer = {
          first_name: buyer.name,
          taxpayer_id: buyer.cpf,
          email: buyer.email,
          address: {
            line1: buyer.address.address + ", " + buyer.address.address_number,
            line2: buyer.address.complement ? buyer.address.complement : "",
            neighborhood: buyer.address.district,
            city: buyer.address.city,
            state: buyer.address.state.sigla,
            postal_code: buyer.address.postal_code,
            country_code: buyer.address.contry.sigla,
          },
        };
        // console.log('newBuyer: ', JSON.stringify(newBuyer))
        addBuyer(newBuyer)
          .then((buyer) => {
            this.geraBoleto(invoice, buyer.buyer_id)
              .then((boleto) => {
                // console.log('boleto: ', boleto)
                // console.log('competence: ', invoice.competence)
                const month = invoice.competence.toString().split("-")[1];
                const year = invoice.competence.toString().split("-")[0];
                // console.log('comp: ' + year + '-' + month )
                const invoice_update = {
                  competence: year + "-" + month,
                  transaction_id: boleto.data.id,
                  transaction_history: boleto.data.history,
                  transaction_status: boleto.data.status,
                  transaction_customer: boleto.data.customer,
                  transaction_created_at: boleto.data.updated_at,
                  "transaction.payment_method": boleto.data.payment_method,
                };
                updateInvoice(buyer.customer_id, invoice_update)
                  .then(() => {
                    // console.log(req)
                    this.loading_faturar = false;
                    this.snack(
                      "Boleto gerado com sucesso!",
                      "success",
                      "bottom",
                    );

                    // this.$route.replace('membros/faturas/' + this.buyer_id.customer_id)
                  })
                  .catch((error) => {
                    console.error(
                      "Erro ao atualizar a fatura, transação realizada com o número: " +
                        boleto.data.id +
                        " Erro: " +
                        error,
                    );
                    this.loading_faturar = false;
                    this.snack(
                      "Erro ao atualizar a fatura, transação realizada com o número: " +
                        boleto.data.id +
                        " Erro: " +
                        error,
                      "error",
                      "bottom",
                    );
                  });
              })
              .catch((error) => {
                console.error("Erro ao gerar boleto - Erro: " + error);
                this.loading_faturar = false;
                this.snack(
                  "Erro ao gerar boleto - Erro: " + error,
                  "error",
                  "bottom",
                );
              });
          })
          .catch((error) => {
            console.error("Erro ao gerar boleto - Erro: " + error);
            this.loading_faturar = false;
            this.snack(
              "Erro ao gerar boleto - Erro: " + error,
              "error",
              "bottom",
            );
          });
      }
      // console.log('invoice:', invoice)
    },
    async geraBoleto(invoice, buyer_id) {
      const boleto_month = invoice.competence.toString().split("-")[1];
      const boleto_year = invoice.competence.toString().split("-")[0];
      var boleto_now = new Date();
      var payment_limit_date = moment(boleto_now).add("days", 60);
      // console.log('payment_limit_date: ', payment_limit_date)
      var expiration_date = moment(boleto_now).add("days", 15);
      var month = boleto_now.getMonth();
      boleto_now.setMonth(month + 1);
      const boleto = {
        amount: invoice.total * 100,
        currency: "BRL",
        description:
          "Créditos de Energia Limpa - Referência: " +
          boleto_month +
          "/" +
          boleto_year,
        reference_id: "enercred_" + boleto_month + "_" + boleto_year,
        on_behalf_of: process.env.VUE_APP_ZOOP_SELLER_ID,
        customer: buyer_id,
        payment_type: "boleto",
        payment_method: {
          expiration_date: expiration_date.toISOString().substr(0, 10),
          payment_limit_date: payment_limit_date.toISOString().substr(0, 10),
          body_instructions: [
            "Créditos de Energia Limpa - Referência: " +
              boleto_month +
              "/" +
              boleto_year +
              "<br> Não receber após " +
              moment(expiration_date.toISOString().substr(0, 10)).format(
                "DD/MM/YYYY",
              ),
          ],
          billing_instructions: {
            late_fee: {
              mode: "FIXED",
              amount: 500,
            },
            interest: {
              mode: "DAILY_AMOUNT",
              amount: 200,
            },
          },
        },
      };
      // console.log('boleto:', JSON.stringify(boleto))
      return addTransaction(boleto);
    },

    snack(message, color, ...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = color;
      this.snackMessage = message;
      this.snackbar = true;
    },
    formatCurrency(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return "R$ " + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatCurrencyEmail(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    copyTestingCode() {
      let testingCodeToCopy = document.querySelector("#testing-code");
      testingCodeToCopy.setAttribute("type", "text"); //hidden
      testingCodeToCopy.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "sucesso" : "insucesso";
        // alert('Testing code was copied ' + msg);
        this.snack(
          "Código de barras copiado com " + msg + "!",
          "success",
          "top",
        );
      } catch (err) {
        // alert('Oops, unable to copy');
        this.snack(
          "Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.",
          "error",
          "top",
        );
      }

      /* unselect the range */
      testingCodeToCopy.setAttribute("type", "hidden");
      window.getSelection().removeAllRanges();
    },
  },
  filters: {
    formatarData: function (value) {
      if (!value) return "";
      // console.log(value)
      let timestamp = value; // firebase data
      let myDate = new Date();
      if (timestamp._seconds) {
        myDate = new Date(timestamp._seconds * 1000); // date object
      } else {
        myDate = new Date(timestamp); // date object
      }

      // console.log(myDate)
      return moment(myDate.toISOString().substr(0, 10)).format("MM/YYYY");
    },
    formatStatus: function (value) {
      if (!value) return "";
      if (
        value === "paga" ||
        value === "succeeded" ||
        value === "paid" ||
        value === "free"
      ) {
        return "done_outline";
      } else if (
        value === "aberta" ||
        value === "processing" ||
        value === "pending" ||
        value === "waiting_payment" ||
        value === "opened"
      ) {
        return "schedule";
      } else if (value === "overdue") {
        return "schedule";
      } else {
        return "error";
      }
    },
    formatCurrency(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
};
</script>
<style scoped>
.line {
  padding-top: 5px;
  height: 60px;
  vertical-align: middle;
}
.card-text {
  height: 100%;
  font-size: 18px;
  padding: 10px 20px 10px 20px;
}

.concessionaria {
  border: 1px solid #dbdbdb;
}

.energia-limpa {
  border: 1px solid #dbdbdb;
}

.economia {
  border: 1px solid #dbdbdb;
}

.valores {
  font-size: medium;
}
</style>
